<template>
  <section>
    <buscar-producto @seleccionado="onSeleccionado" />
    <mensaje-inicial
      :titulo="'No has agregado productos'"
      :subtitulo="'Agrega algunos productos a la lista para venderlos :)'"
      v-if="productos.length < 1"
    />
    <b-modal
      v-model="abrirModalLocal"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-label="Modal Seleccionar Local"
      close-button-aria-label="Close"
      aria-modal
    >
      <div class="modal-card" style="width: 320px">
        <section class="modal-card-body">
          <b-field class="mt-3" label="Local emisor">
            <b-select
              class="wide"
              placeholder="Seleccionar..."
              v-model="local"
              required
            >
              <option value="jiro">Jirosushi Prime</option>
              <option value="ccs">Oferta Caracas</option>
              <option value="prime">Food Prime</option>
            </b-select>
          </b-field>
        </section>
        <footer class="modal-card-foot" style="justify-content: flex-end">
          <b-button
            label="Continuar"
            type="is-primary"
            @click="confirmarLocal"
            :disabled="!local"
          />
        </footer>
      </div>
    </b-modal>
    <div v-if="productos.length > 0">
      <tabla-productos
        :listaProductos="productos"
        @quitar="onQuitar"
        @aumentar="onAumentar"
        @precioCambiado="calcularTotal"
      />
      <div class="notification is-primary panel-venta-total mt-3">
        <p class="has-text-weight-bold has-text-centered total-venta" style="font-size: clamp(2rem, 7vw, 3.6rem); line-height: 1.1">
          Total ${{ formatoMonto(total.toFixed(2)) }}
        </p>
        <p class="has-text-weight-bold has-text-centered total-venta" style="font-size: clamp(1.2rem, 4vw, 2rem); line-height: 1.1; opacity: 0.95">
          Total Bs. {{ formatoMonto(total.toFixed(2) * tasa) }}
        </p>
        <nav class="level mt-2 acciones-venta">
          <div
            class="level-item has-text-centered"
            v-if="can('ventas.registrar_venta')"
          >
            <b-button
              class="button is-responsive"
              type="is-success"
              inverted
              icon-left="check"
              size="is-large"
              @click="abrirDialogo('venta')"
            >
              Vender al contado
            </b-button>
          </div>
          <div
            class="level-item has-text-centered"
            v-if="can('ventas.registrar_cuenta')"
          >
            <b-button
              class="button is-responsive"
              type="is-info"
              inverted
              icon-left="wallet-plus"
              size="is-large"
              @click="abrirDialogo('cuenta')"
            >
              Vender a crédito
            </b-button>
          </div>
          <div
            class="level-item has-text-centered"
            v-if="can('ventas.registrar_apartado')"
          >
            <b-button
              class="button is-responsive"
              type="is-dark"
              inverted
              icon-left="wallet-travel"
              size="is-large"
              @click="abrirDialogo('apartado')"
            >
              Realizar apartado
            </b-button>
          </div>
          <div class="level-item has-text-centered">
            <b-button
              class="button is-responsive"
              type="is-danger"
              inverted
              icon-left="cancel"
              size="is-large"
              @click="cancelarVenta"
            >
              Cancelar
            </b-button>
          </div>
          <div
            class="level-item has-text-centered"
            v-if="can('ventas.registrar_cotiza')"
          >
            <b-button
              class="button is-responsive"
              type="is-warning"
              inverted
              icon-left="ticket-outline"
              size="is-large"
              @click="abrirDialogo('cotiza')"
            >
              Cotizar
            </b-button>
          </div>
        </nav>
      </div>
    </div>
    <b-loading
      :is-full-page="true"
      v-model="cargando"
      :can-cancel="false"
    ></b-loading>
    <b-modal
      v-model="mostrarDialogo"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-label="Modal Terminar Venta"
      close-button-aria-label="Close"
      aria-modal
    >
      <dialogo-terminar-venta
        :totalVenta="total"
        @close="onCerrar"
        @terminar="onTerminar"
        v-if="mostrarTerminarVenta"
        :metodos="metodos"
        :choferes="choferes"
        @actualizar="actualizar"
        :enviando="registrando"
      ></dialogo-terminar-venta>
      <dialogo-agregar-cuenta-apartado
        :totalVenta="total"
        @close="onCerrar"
        @terminar="onTerminar"
        v-if="mostrarAgregarCuenta"
        :metodos="metodos"
        :choferes="choferes"
        @actualizar="actualizar"
        tipo="cuenta"
      ></dialogo-agregar-cuenta-apartado>
      <dialogo-agregar-cuenta-apartado
        :totalVenta="total"
        @close="onCerrar"
        @terminar="onTerminar"
        v-if="mostrarAgregarApartado"
        :metodos="metodos"
        :choferes="choferes"
        @actualizar="actualizar"
        tipo="apartado"
      ></dialogo-agregar-cuenta-apartado>
      <dialogo-cotizar
        :totalVenta="total"
        :listaProductos="productos"
        @close="onCerrar"
        @terminar="onTerminar"
        v-if="mostrarRegistrarCotizacion"
      ></dialogo-cotizar>
    </b-modal>
    <comprobante-compra
      :venta="this.ventaRealizada"
      :tipo="tipoVenta"
      @impreso="onImpreso"
      v-if="mostrarComprobante"
      :local="local"
      :porPagar="porPagar"
      :tamaño="tamaño"
      :enviarCliente="enviarCliente"
      :tasa="tasa"
    />
  </section>
</template>
<script>
import BuscarProducto from "../Inventario/BuscarProducto.vue";
import TablaProductos from "./TablaProductos.vue";
import DialogoTerminarVenta from "./DialogoTerminarVenta";
import DialogoAgregarCuentaApartado from "./DialogoAgregarCuentaApartado.vue";
import DialogoCotizar from "./DialogoCotizar";
import ComprobanteCompra from "./ComprobanteCompra";
import MensajeInicial from "../Extras/MensajeInicial";
import AyudanteSesion from "../../Servicios/AyudanteSesion";
import HttpService from "../../Servicios/HttpService";
import Utiles from "../../Servicios/Utiles";

export default {
  name: "RealizarVenta",
  components: {
    BuscarProducto,
    TablaProductos,
    DialogoTerminarVenta,
    DialogoAgregarCuentaApartado,
    DialogoCotizar,
    MensajeInicial,
    ComprobanteCompra,
  },

  data: () => ({
    tasa: null,
    cargando: false,
    tamaño: "tiquera",
    productos: [],
    choferes: [],
    metodos: [],
    total: 0,
    porPagar: 0,
    costoDelivery: null,
    esDelivery: false,
    deliveryGratis: false,
    mostrarDialogo: false,
    mostrarTerminarVenta: false,
    mostrarAgregarCuenta: false,
    mostrarAgregarApartado: false,
    mostrarRegistrarCotizacion: false,
    ventaRealizada: null,
    mostrarComprobante: false,
    enviarCliente: false,
    tipoVenta: "",
    local: null,
    abrirModalLocal: false,
    ventaPendiente: null,
    // Clave de idempotencia de la venta en curso: se reutiliza en cada reintento para que
    // un doble clic, un doble Enter o un reintento tras un timeout no creen dos ventas.
    // Se renueva despues de cada registro exitoso.
    idempotenciaVenta: null,
    // Bloquea el doble envio mientras la peticion esta en vuelo.
    registrando: false,
  }),

  computed: {
    idNegocioDeLocal ()
    {
      const mapa = { jiro: 1, ccs: 2, prime: 3 }
      return this.local ? (mapa[this.local] || null) : null
    },
  },

  mounted() {
    this.cargando = true;
    const payload = { accion: "obtener" };

    Promise.all([
      HttpService.obtenerConConsultas("ventas.php", { accion: "obtener_tasa" }),
      HttpService.obtenerConConsultas("metodos.php", payload),
      HttpService.obtenerConConsultas("choferes.php", payload),
    ]).then(([tasa, metodos, choferes]) => {
      this.tasa = tasa.valor ?? 0;
      this.metodos = metodos;
      this.choferes = choferes;
      this.cargando = false;
    });
  },

  methods: {
    formatoMonto(valor) {
      return Utiles.formatoMonto(valor);
    },

    onImpreso(resultado) {
      this.mostrarComprobante = resultado;
    },

    actualizar(prop, valor) {
      this[prop] = valor;
      this.calcularTotal();
    },

    /** Re-valida TODOS los productos y clampa los que excedan su stock efectivo */
    revalidarStock() {
      let huboCambio = false;
      this.productos.forEach((producto) => {
        // Sanitizar: cantidad vacía/NaN → 0, negativa → 0
        const cant = parseFloat(producto.cantidad);
        if (isNaN(cant) || cant < 0) {
          producto.cantidad = 0;
          huboCambio = true;
        }

        const maxExistencia = this.existenciaEfectiva(producto);
        if (parseFloat(producto.cantidad) > parseFloat(maxExistencia)) {
          this.$buefy.toast.open({
            type: "is-warning",
            duration: 10000,
            message:
              `"${producto.nombre}" se ajustó de ${producto.cantidad} a ${maxExistencia} (stock disponible).` +
              this.explicarLimiteStock(producto),
          });
          producto.cantidad = Number(maxExistencia);
          huboCambio = true;
        }
      });
      if (huboCambio) this.calcularTotal();
    },

    /**
     * Genera una clave unica para esta venta. crypto.randomUUID solo existe en contexto
     * seguro (HTTPS o localhost): el fallback cubre servir la app por http en la red local.
     */
    generarClaveIdempotencia() {
      if (
        typeof crypto !== "undefined" &&
        typeof crypto.randomUUID === "function"
      ) {
        return crypto.randomUUID();
      }

      return (
        "venta-" +
        Date.now().toString(36) +
        "-" +
        Math.random().toString(36).slice(2, 12)
      );
    },

    async onTerminar(venta) {
      // Un clic = un envio. Sin esta guarda, dos clics o dos Enter rapidos (el form tiene
      // @submit.prevent) disparan dos registros y crean dos ventas.
      if (this.registrando) return;

      // Clave estable para esta venta: si el usuario reintenta (timeout, doble envio), el
      // servidor devuelve la venta ya registrada en vez de crear otra.
      if (!this.idempotenciaVenta) {
        this.idempotenciaVenta = this.generarClaveIdempotencia();
      }

      this.calcularTotal();

      // ── Validar stock de TODOS los productos antes de procesar ──
      for (const producto of this.productos) {
        const maxExistencia = this.existenciaEfectiva(producto);
        if (parseFloat(producto.cantidad) > parseFloat(maxExistencia)) {
          this.$buefy.toast.open({
            type: "is-danger",
            duration: 12000,
            message:
              `Stock insuficiente para "${producto.nombre}". ` +
              `Tienes ${producto.cantidad} pero el máximo es ${maxExistencia}. ` +
              `Faltan ${parseFloat(producto.cantidad) - parseFloat(maxExistencia)} unidades.` +
              this.explicarLimiteStock(producto),
          });
          this.cargando = false;
          return;
        }
      }

      // Seleccionar negocio/local antes de guardar
      if (!this.local) {
        this.ventaPendiente = venta;
        // Cerrar el diálogo principal antes de abrir el modal de local
        this.mostrarTerminarVenta =
          this.mostrarAgregarCuenta =
          this.mostrarAgregarApartado =
          this.mostrarRegistrarCotizacion =
            false;
        this.mostrarDialogo = false;
        this.abrirModalLocal = true;
        return;
      }

      return this.continuarRegistro(venta);
    },

    async continuarRegistro(venta) {
      if (this.registrando) return;
      this.registrando = true;

      let total = this.total;

      let tasa = null;

      if (venta.moneda === "bs") {
        try {
          const resultado = await HttpService.registrar("ventas.php", {
            accion: "obtener_tasa",
          });

          tasa = resultado.id;
        } catch (error) {
          // Si falla la tasa no se registra nada: liberar el bloqueo para no dejar el
          // botón de "Terminar venta" deshabilitado para siempre.
          this.registrando = false;
          this.cargando = false;
          this.$buefy.toast.open({
            type: "is-danger",
            message: error?.message || "No se pudo obtener la tasa. Intenta de nuevo.",
          });
          return;
        }
      }

      // For cotizacion, use the dialog's productos (which include tipoImpuesto per line).
      // For other types, use the main product list.
      const productosFuente =
        venta.tipo === "cotiza" && Array.isArray(venta.productos)
          ? venta.productos
          : this.productos;

      const ventaPayload = {
        total,
        productos: productosFuente,
        cliente: venta.cliente.id,
        usuario: AyudanteSesion.usuario().id,
        nombreCliente: venta.cliente.nombre
          ? venta.cliente.nombre
          : "MOSTRADOR",
        nombreUsuario: AyudanteSesion.usuario().usuario,
        telefonoCliente: venta.cliente.telefono,
        direccionCliente: venta.delivery?.destino ?? venta.cliente.direccion,
        ...(venta.moneda === "bs" && {
          idTasa: tasa,
        }),
        fecha: new Intl.DateTimeFormat("es-ES", {
          dateStyle: "short",
          timeStyle: "medium",
        })
          .format(new Date())
          .replace(/-/g, "/"),
      };

      let tipo = venta.tipo;
      ventaPayload.tipo = tipo;
      ventaPayload.idNegocio = this.idNegocioDeLocal;

      // Clave de idempotencia para que un reintento o un doble envio no dupliquen la venta.
      // No aplica a cotizaciones (no son un cobro y no comparten esta proteccion).
      if (tipo !== "cotiza") {
        ventaPayload.idempotencia = this.idempotenciaVenta;
      }

      switch (tipo) {
        case "venta":
          ventaPayload.pagado = venta.pagado;
          ventaPayload.simple = venta.simple;
          ventaPayload.origen = venta.origen;
          ventaPayload.idMetodo = venta.idMetodo;
          ventaPayload.pagos = venta.pagos;
          ventaPayload.delivery = venta.delivery;
          ventaPayload.chofer = venta.chofer;
          break;

        case "cotiza":
          ventaPayload.hasta = venta.hasta;
          break;

        default:
          ventaPayload.pagado = venta.pagado;
          ventaPayload.simple = venta.simple;
          ventaPayload.origen = venta.origen;
          ventaPayload.idMetodo = venta.idMetodo;
          ventaPayload.delivery = venta.delivery;
          ventaPayload.chofer = venta.chofer;
          ventaPayload.dias = venta.dias;
          break;
      }

      if (tipo !== "cotiza" && ventaPayload.pagado === "") {
        ventaPayload.pagado = 0;
      }

      this.tipoVenta = venta.tipo;
      this.ventaRealizada = null;

      this.cargando = true;
      let datos = {
        accion: "registrar_" + tipo,
        datos: ventaPayload,
      };

      this.costoDelivery = null;
      this.esDelivery = false;
      this.deliveryGratis = false;

      HttpService.registrar("ventas.php", datos)
        .then((resultado) => {
          const id = resultado?.id;
          const porPagar = resultado?.porPagar;

          if (!id) {
            this.cargando = false;
            // Se conserva la clave de idempotencia: si la venta sí llegó a guardarse pese
            // al error/timeout, un reintento devuelve la misma venta en vez de duplicarla.
            this.registrando = false;
            this.$buefy.toast.open({
              type: "is-danger",
              message:
                (resultado?.detalle
                  ? resultado.error + " — " + resultado.detalle
                  : resultado?.error) ||
                "Error al registrar la venta. Verifica los datos.",
            });
            return false;
          }

          this.ventaRealizada = {
            ...ventaPayload,
            id,
          };
          this.productos = [];
          this.total = 0;
          this.cargando = false;
          // Ya quedó guardado: liberar el bloqueo y renovar la clave para la próxima venta.
          this.registrando = false;
          this.idempotenciaVenta = null;
          this.mostrarTerminarVenta =
            this.mostrarAgregarCuenta =
            this.mostrarAgregarApartado =
            this.mostrarRegistrarCotizacion =
              false;
          this.mostrarDialogo = false;
          this.$buefy.toast.open({
            type: "is-info",
            message: tipo.toUpperCase() + " registrado con éxito",
          });

          if (resultado?.duplicado) {
            this.$buefy.toast.open({
              type: "is-warning",
              duration: 8000,
              message:
                "Este registro ya estaba guardado: no se duplicó. Se muestra el comprobante existente.",
            });
          }

          // El sistema puede haber abierto envases para completar la venta: eso cambia el
          // inventario (suma unidades al detal y descuenta el envase) y el operador tiene
          // que verlo, no solo "registrado con éxito".
          Utiles.mensajesDesempaquetado(resultado).forEach((mensaje) =>
            this.$buefy.toast.open(mensaje)
          );

          if (this.tipoVenta === "cuenta" || this.tipoVenta === "apartado") {
            this.porPagar = porPagar;
          }

          return true;
        })
        .then((registroExitoso) => {
          if (!registroExitoso || !this.ventaRealizada?.id) {
            return;
          }

          this.$buefy.dialog.confirm({
            message: "Selecciona el tamaño a imprimir",
            cancelText: "Carta",
            confirmText: "Tiquera",
            trapFocus: true,
            onConfirm: () => {
              this.tamaño = "tiquera";
              this.confirmarEnvioCliente();
            },
            onCancel: () => {
              this.tamaño = "carta";
              this.confirmarEnvioCliente();
            },
          });
        })
        .catch((err) => {
          this.cargando = false;
          // Se conserva idempotenciaVenta para que un reintento no duplique la venta.
          this.registrando = false;
          this.$buefy.toast.open({
            type: "is-danger",
            message: err?.message || "Ocurrió un error inesperado al registrar la venta.",
          });
        });
    },

    confirmarLocal() {
      this.abrirModalLocal = false;
      if (this.ventaPendiente) {
        const pendiente = this.ventaPendiente;
        this.ventaPendiente = null;
        this.continuarRegistro(pendiente);
        return;
      }
      this.confirmarEnvioCliente();
    },

    confirmarEnvioCliente() {
      this.$buefy.dialog.confirm({
        message: "¿Enviar al cliente mediante WhatsApp?",
        cancelText: "No",
        confirmText: "Sí",
        trapFocus: true,
        onConfirm: () => {
          this.enviarCliente = true;
          this.mostrarComprobante = true;
        },
        onCancel: () => {
          this.enviarCliente = false;
          this.mostrarComprobante = true;
        },
      });
    },

    cancelarVenta() {
      this.$buefy.dialog.confirm({
        title: "Cancelar venta",
        message: "¿Seguro que deseas cancelar la venta?",
        confirmText: "Sí, cancelar",
        cancelText: "No, continuar",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          this.productos = [];
          this.total = 0;
          this.$buefy.toast.open("Venta cancelada");
        },
      });
    },

    abrirDialogo(opcion) {
      this.mostrarTerminarVenta = false;
      this.mostrarAgregarCuenta = false;
      this.mostrarAgregarApartado = false;
      this.mostrarRegistrarCotizacion = false;

      this.$nextTick(() => {
        this.mostrarDialogo = true;
        switch (opcion) {
          case "venta":
            this.mostrarTerminarVenta = true;
            break;
          case "cuenta":
            this.mostrarAgregarCuenta = true;
            break;
          case "apartado":
            this.mostrarAgregarApartado = true;
            break;
          case "cotiza":
            this.mostrarRegistrarCotizacion = true;
            break;
        }
      });
    },

    onCerrar(opcion) {
      this.mostrarDialogo = false;
      if (
        opcion === "venta" ||
        opcion === "cuenta" ||
        opcion === "apartado" ||
        opcion === "cotiza"
      ) {
        this.mostrarTerminarVenta =
          this.mostrarAgregarCuenta =
          this.mostrarAgregarApartado =
          this.mostrarRegistrarCotizacion =
            false;
      }
    },

    onQuitar(id) {
      let indice = this.productos.findIndex((producto) => producto.id === id);
      if (indice < 0) return;
      this.productos.splice(indice, 1);
      this.calcularTotal();
      // Re-validar cross-deducciones: al remover un producto, los demás
      // que dependían de él (vía paquetes_de) recuperan su stock efectivo.
      this.revalidarStock();
    },

    onAumentar(producto) {
      // ── Sanitizar cantidad ──
      // El input type="number" permite vacío, negativos, NaN si el usuario
      // escribe libremente. Normalizar a 0 para evitar cálculos rotos.
      const raw = producto.cantidad;
      if (raw === '' || raw === null || raw === undefined) {
        producto.cantidad = 0;
      } else {
        const cant = parseFloat(raw);
        if (isNaN(cant) || cant < 0) {
          producto.cantidad = 0;
        }
      }

      let verificaExistencia = this.verificarExistenciaAlcanzada(
        producto.existencia,
        producto.id
      );

      if (verificaExistencia) return;

      if (producto.vendidoMayoreo) {
        this.verificarMayoreo(
          producto.cantidadMayoreo,
          producto.id,
          producto.precioMayoreo
        );
      }
      this.calcularTotal();
      // Re-validar otros productos afectados por cross-deducción
      this.revalidarStock();
    },

    onSeleccionado(producto) {
      let existeEnLista = this.verificarSiEstaEnLista(producto.id);

      // Si ya está en carrito, actualizar stock y paquetes desde el resultado
      // fresco del servidor. Si el stock cambió externamente, la existencia
      // en el carrito estaba obsoleta y causaría validaciones incorrectas.
      if (existeEnLista >= 0) {
        const enCarrito = this.productos[existeEnLista];
        enCarrito.existencia = producto.existencia;
        if (Array.isArray(producto.paquetes)) {
          enCarrito.paquetes = producto.paquetes;
        }
        if (producto.paquetes_de) {
          enCarrito.paquetes_de = producto.paquetes_de;
        }
      }

      let verificaExistencia = this.verificarExistenciaAlcanzada(
        producto.existencia,
        producto.id
      );

      if (verificaExistencia) return;

      if (producto.vendidoMayoreo) {
        this.verificarMayoreo(
          producto.cantidadMayoreo,
          producto.id,
          producto.precioMayoreo
        );
      }

      if (existeEnLista >= 0) {
        this.aumentarCantidad(existeEnLista);
        this.calcularTotal();
        this.revalidarStock();
        return;
      }

      this.agregarALista(producto);
      this.calcularTotal();
      this.revalidarStock();
    },

    agregarALista(producto) {
      this.productos.push({
        id: producto.id,
        codigo: producto.codigo,
        nombre: producto.nombre,
        precio: producto.precioVenta,
        precioVenta: producto.precioVenta,
        precioVenta2: producto.precioVenta2,
        precioVenta3: producto.precioVenta3,
        precioVenta4: producto.precioVenta4,
        precioVenta5: producto.precioVenta5,
        precioVenta6: producto.precioVenta6,
        precioVenta7: producto.precioVenta7,
        unidad: producto.unidad,
        cantidad: 1,
        existencia: producto.existencia,
        vendidoMayoreo: producto.vendidoMayoreo,
        cantidadMayoreo: producto.cantidadMayoreo,
        precioMayoreo: producto.precioMayoreo,
        mayoreoAplicado: false,
        conversiones: Array.isArray(producto.conversiones)
          ? producto.conversiones
          : [],
        conversionSel: -1,
        factorConversion: 1,
        unidadSel: producto.unidad,
        paquetes: Array.isArray(producto.paquetes) ? producto.paquetes : [],
        paquetes_de: producto.paquetes_de || null,
      });
    },

    /**
     * Explica POR QUE un producto se queda sin stock disponible.
     *
     * Sin esto el operador solo ve "excede la existencia máxima" y no puede saber si le
     * falta REGISTRAR el producto empaquetado, si está sin stock o si la vinculación está
     * invertida: los cuatro casos se ven exactamente igual.
     */
    explicarLimiteStock(producto) {
      const paquetes = Array.isArray(producto.paquetes) ? producto.paquetes : []

      // 1) Este producto ES el empaquetado de otro: sus unidades se consumen al abrir.
      if (producto.paquetes_de) {
        const consumidos = Utiles.envasesConsumidosPorDetalle(
          producto,
          this.productos
        )
        if (consumidos > 0) {
          return (
            " Su stock está comprometido para abastecer " +
            (producto.paquetes_de.nombre_base || "el producto detal") +
            "."
          )
        }
        return ""
      }

      // 2) Sin productos empaquetados vinculados: falta registrar la relación o el
      //    producto se abastece solo con lo que hay del producto detal.
      if (paquetes.length === 0) {
        return (
          " Si se abastece abriendo un producto empaquetado (caja, bolsa, bulto)," +
          " registra la vinculación en Inventario → editar producto → Productos" +
          " empaquetados."
        )
      }

      // 3) Productos empaquetados vinculados pero sin stock.
      const conStock = paquetes.filter(
        (p) => (parseFloat(p.existencia_paquete) || 0) > 0
      )
      if (conStock.length === 0) {
        return (
          " Tiene productos empaquetados vinculados (" +
          paquetes.map((p) => p.nombre_paquete).join(", ") +
          ") pero están sin stock."
        )
      }

      // 4) Empaquetados con stock pero con la relación invertida: el backend los rechaza.
      const invertido = conStock.find((p) => !Utiles.puedeAbrirEnvase(p))
      if (invertido) {
        return (
          " El producto empaquetado " +
          invertido.nombre_paquete +
          " rinde menos de 1 unidad del producto detal (vinculación invertida): corrígela" +
          " en Inventario → Auditoría de productos empaquetados."
        )
      }

      return ""
    },

    verificarExistenciaAlcanzada(existencia, id) {
      let resultado = false;
      this.productos.forEach((producto) => {
        if (producto.id === id) {
          let maxExistencia = this.existenciaEfectiva(producto);
          // Solo bloquear si EXCEDE el stock (>) — poder vender hasta agotar (quedar 0)
          if (parseFloat(producto.cantidad) > parseFloat(maxExistencia)) {
            this.$buefy.toast.open({
              type: "is-danger",
              duration: 10000,
              message:
                "El producto " +
                producto.nombre +
                " excede la existencia máxima. Solo tienes " +
                maxExistencia +
                "." +
                this.explicarLimiteStock(producto),
            });
            producto.cantidad = Number(maxExistencia);
            // Recalcular total inmediatamente
            this.calcularTotal();
            resultado = true;
          }
        }
      });
      return resultado;
    },

    /** Stock efectivo total (base + paquetes - deducción cruzada).
     *  Este es el LÍMITE MÁXIMO que el usuario puede tener en el carrito.
     *  NO descuenta la cantidad ya en carrito (porque se usa para verificar
     *  si `cantidad >= límite`).
     *  Para ver el stock restante (disponible para agregar), se debe restar
     *  la cantidad actual del producto.
     */
    existenciaEfectiva(producto) {
      // Stock base + unidades que aportan los envases CON STOCK, menos lo que el detalle
      // ya vendido por encima de su stock consumiría de esos envases.
      // Un envase cuya vinculación no puede rendir 1 unidad no se cuenta: el backend lo
      // rechaza, así que prometerlo aquí solo generaría un error al cerrar la venta.
      const base = parseFloat(producto.existencia) || 0;
      const conEnvases = base + Utiles.unidadesDesdeEnvases(producto);
      const consumido = Utiles.envasesConsumidosPorDetalle(
        producto,
        this.productos
      );

      return Math.max(0, conEnvases - consumido);
    },

    /** Stock RESTANTE (lo que realmente queda disponible para agregar).
     *  = existenciaEfectiva - cantidad actual del producto en el carrito.
     *  Esto es lo que debería mostrar la UI como "stock disponible"
     *  y se actualiza correctamente al remover/disminuir el producto.
     */
    stockRestante(producto) {
      const maximo = this.existenciaEfectiva(producto);
      const cantidad = parseFloat(producto.cantidad) || 0;
      return Math.max(0, maximo - cantidad);
    },

    verificarMayoreo(cantidadMayoreo, id, precioMayoreo) {
      this.productos.forEach((producto) => {
        if (producto.id !== id) return;

        if (producto.cantidad >= parseInt(cantidadMayoreo)) {
          if (producto.mayoreoAplicado) return;
          this.$buefy.dialog.confirm({
            confirmText: "Sí, aplicar",
            cancelText: "No aplicar",
            message:
              "El producto " +
              producto.nombre +
              " tiene mayoreo a partir de " +
              cantidadMayoreo +
              " piezas, ¿Desea aplicar el mayoreo?",
            onConfirm: () => {
              producto.precio = precioMayoreo;
              producto.mayoreoAplicado = true;
              this.$buefy.toast.open(
                "Mayoreo aplicado correctamente a " + producto.nombre
              );

              this.calcularTotal();
            },
          });
        } else {
          producto.precio = producto.precioVenta;
          producto.mayoreoAplicado = false;
        }
      });
    },

    verificarSiEstaEnLista(id) {
      return this.productos.findIndex((producto) => producto.id === id);
    },

    aumentarCantidad(indice) {
      let lista = this.productos;
      let producto = lista[indice];
      producto.cantidad++;
      this.productos = lista;
    },

    calcularTotal() {
      const total = this.productos.reduce((acc, producto) => {
        const cantidad = Number(producto.cantidad) || 0;
        const precio = Number(producto.precio) || 0;
        const sub = cantidad * precio;
        return acc + (isNaN(sub) ? 0 : sub);
      }, 0);

      const costo = Number(this.costoDelivery) || 0;
      let suma = total;
      if (this.esDelivery && !this.deliveryGratis && !isNaN(costo)) {
        suma += costo;
      }

      this.total = parseFloat(suma.toFixed(2));
    },
  },

  watch: {
    mostrarDialogo(newValue) {
      if (!newValue) {
        this.costoDelivery = 0;
        this.deliveryGratis = false;
        this.esDelivery = false;
        this.calcularTotal();
      }
    },
  },
};
</script>

<style scoped>
  /* Pantallas táctiles/móviles: botones de acción a ancho completo */
  @media (max-width: 767px) {
    .acciones-venta {
      flex-wrap: wrap;
      gap: 8px;
    }

    .acciones-venta .level-item {
      width: 100%;
      margin: 0;
    }

    .acciones-venta .button {
      width: 100%;
      margin: 0;
    }
  }
</style>
